import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { env } from "../env";
import { getLocalStorage } from "../utils/function/localStorage";

export const quizApi = createApi({
    reducerPath: "quizApi",
    baseQuery: fetchBaseQuery({
        baseUrl: env.BASE_URL,
        prepareHeaders: (headers) => {
            headers.set("X-Auth-Token", getLocalStorage("tp_Aa_uth_access"));
            return headers;
        },
    }),
    tagTypes: ["createQuiz"],
    endpoints: builder => ({
        getQuestions: builder.query({
            query: (quizId) =>
                `/secure/getQuestionsBusiness?quizId=${quizId}`,
            providesTags: ['createQuiz', 'challenge'],
        }),

        getOpponent: builder.query({
            query: (quizId) =>
                `/secure/getOpponent?quizId=${quizId}`,
            providesTags: ['createQuiz'],
        }),

        createQuiz: builder.mutation({
            query: body => ({
                url: '/secure/createQuizBusiness',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['createQuiz'],
        }),

        submitQuiz: builder.mutation({
            query: body => ({
                url: '/secure/submitedQuizBusiness',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['createQuiz'],
        }),

        addStartDateTimeQuiz: builder.mutation({
            query: body => ({
                url: '/secure/addStartDateTimeQuiz',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['createQuiz'],
        }),

        getAllQuizLeaderBoardLiveData: builder.query({
            query: ({ page, limit, type }) => {
                const actualType = type ? type : "daily";
                return `/secure/getAllQuizLeaderBoardLiveData?type=${actualType}&${actualType}Page=${page}&${actualType}Limit=${limit}`;
            },
            providesTags: ["leaderBoard"],
        }),

        getMyQuizLeaderBoardStats: builder.query({
            query: ({ type }) => {
                const actualType = type ? type : "daily";
                return `/secure/getMyQuizLeaderBoardStats?type=${actualType}&${actualType}`;
            },
            providesTags: ["leaderBoard"],
        }),
        searchOpponent: builder.query({
            query: (username) => `/secure/search-opponent?username=${username}`,
            providesTags: ["challenge"],
        }),


        sendChallenge: builder.mutation({
            query: (body) => ({
                url: "/secure/send-quiz-challenge",
                method: "POST",
                body,
            }),
            invalidatesTags: ["challenge"],
        }),


        respondToChallenge: builder.mutation({
            query: (body) => ({
                url: "/secure/respond-quiz-challenge",
                method: "POST",
                body,
            }),
            invalidatesTags: ["challenge"],
        }),

        getMyChallenges: builder.query({
            query: () => "/secure/my-quiz-challenges",
            providesTags: ["challenge"],
        }),
    }),
});

export const {

    useGetQuestionsQuery,
    useGetOpponentQuery,
    useCreateQuizMutation,
    useSubmitQuizMutation,
    useAddStartDateTimeQuizMutation,
    useGetAllQuizLeaderBoardLiveDataQuery,
    useGetMyQuizLeaderBoardStatsQuery,
    useRespondToChallengeMutation,
    useGetMyChallengesQuery,

    getChallangeQuestions,
    useSearchOpponentQuery,
    useSendChallengeMutation,

} = quizApi;